import { render, staticRenderFns } from "./VideoLayout.vue?vue&type=template&id=76c52c34&scoped=true"
import script from "./VideoLayout.vue?vue&type=script&lang=js"
export * from "./VideoLayout.vue?vue&type=script&lang=js"
import style0 from "./VideoLayout.vue?vue&type=style&index=0&id=76c52c34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c52c34",
  null
  
)

export default component.exports